import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    CircularProgress,
} from "@mui/material";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const ContentEditorDialog = ({
    open,
    onClose,
    title,
    editorValue,
    onEditorChange,
    onSave,
    saving,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent dividers>
                <ReactQuill
                    theme="snow"
                    value={editorValue}
                    onChange={onEditorChange}
                    modules={{
                        toolbar: [
                            [{ font: [] }],
                            [{ size: ["small", false, "large", "huge"] }],

                            ["bold", "italic", "underline", "strike"],
                            [{ color: [] }, { background: [] }],

                            [{ script: "sub" }, { script: "super" }],

                            [{ header: 1 }, { header: 2 }, "blockquote", "code-block"],

                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ indent: "-1" }, { indent: "+1" }],

                            [{ direction: "rtl" }, { align: [] }],

                            ["link", "image", "video"],

                            ["clean"],
                        ],
                        clipboard: {
                            matchVisual: false,
                        },
                        history: {
                            delay: 500,
                            maxStack: 100,
                            userOnly: true,
                        },
                    }}
                    formats={[
                        "font",
                        "size",
                        "bold",
                        "italic",
                        "underline",
                        "strike",
                        "color",
                        "background",
                        "script",
                        "header",
                        "blockquote",
                        "code-block",
                        "list",
                        "bullet",
                        "indent",
                        "direction",
                        "align",
                        "link",
                        "image",
                        "video",
                    ]}
                    style={{ height: 300, marginBottom: "50px" }}
                />
            </DialogContent>

            <DialogActions sx={{ mt: 2 }}>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={onSave}
                    disabled={saving}
                >
                    {saving ? <CircularProgress size={20} /> : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContentEditorDialog;
